import { createSlice, SerializedError } from "@reduxjs/toolkit";
import { userEntityMemberInvitationApi } from "legal-entities/invitations/member-invitations/email-based/_api/user-entity-member-invitation-api-service";
import { UserEntityMemberInvitationJSON } from "legal-entities/invitations/member-invitations/email-based/_schema/user-entity-member-invitation-schema";

type UserEntityMemberInvitationsState = {
  byId: {
    entries: Record<string, UserEntityMemberInvitationJSON>;
    loading: Record<string, boolean>;
    error: Record<string, SerializedError | null>;

  }
};

const initialState: UserEntityMemberInvitationsState = {
  byId: {
    entries: {},
    loading: {},
    error: {}
  }
};

const userEntityMemberInvitationsSlice = createSlice({
  name: "userEntityMemberInvitations",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addMatcher(userEntityMemberInvitationApi.endpoints.getUserEntityMemberInvitationById.matchPending, (state, action) => {
      const invitationId = action.meta.arg.originalArgs.id?.value;
      if (!invitationId) return;
      state.byId.loading[invitationId] = true;
      state.byId.error[invitationId] = null;
    });
    builder.addMatcher(userEntityMemberInvitationApi.endpoints.getUserEntityMemberInvitationById.matchFulfilled, (state, action) => {
      const invitationId = action.meta.arg.originalArgs.id?.value;
      if (!invitationId) return;
      state.byId.entries[invitationId] = action.payload.toJSON();
      state.byId.loading[invitationId] = false;
      state.byId.error[invitationId] = null;
    });
    builder.addMatcher(userEntityMemberInvitationApi.endpoints.getUserEntityMemberInvitationById.matchRejected, (state, action) => {
      const invitationId = action.meta.arg.originalArgs.id?.value;
      if (!invitationId) return;
      state.byId.loading[invitationId] = false;
      state.byId.error[invitationId] = action.error;
    });
  }
});

export default userEntityMemberInvitationsSlice;
